<template>
  <section class="vorteile base-station">
    <div class="partners-and-trustpilot container">
      <div class="row">
        <div class="col-xs col-lg-12">
          <div class="inner-wrap">
            <div class="partners">
              <span class="section-title">Bekannt aus: </span>
              <div class="partners-icons">
                <a href="https://www.sport1.de/" target="_blank" class="partner-logo partner-logo04">
                  <img src="../assets/sport1.png" alt="Sport1" />
                </a>
                <a href="https://www.prosieben.de/" target="_blank" class="partner-logo partner-logo01">
                  <img src="../assets/pro7.png" alt="Pro7" />
                </a>
                <a href="https://www.rtl.de/" target="_blank" class="partner-logo partner-logo02">
                  <img src="../assets/rtl.png" alt="RTL" />
                </a>
                <a href="https://www.rtl2.de/" target="_blank" class="partner-logo partner-logo03">
                  <img src="../assets/rtlzwei.png" alt="RTLZwei" />
                </a>
              </div>
            </div>
            <div class="divider"></div>
            <div class="trustpilot" >
              <span class="section-title">Das sagen unsere Kunden:</span>
              <div class="trust-items">
                <div class="google-rating-widget">
                    <a href="https://www.google.com/search?q=PKW.de+Digital+Mobility+Solutions+GmbH%2C+Hansaallee+299%2C+40549+D%C3%BCsseldorf%2C+Deutschland#lrd=0x47b8b6774c6145d5:0x857e72330821615c,1,,,," target="_blank">
                      <img src="../assets/google-rating.png" alt="Google Bewertungen" />
                    </a>
                </div>
                <div class="rating-widget base-rating-widget">
                  <div ref="rating"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Vorteile",
  mounted() {
    var s = document.createElement('script');
    var options = {id: 3536};
    s.async = true;
    s.onload = function () {
        getWidget('https://meinebewertungen.pkw.de', '/de', 'kY7Y2P', s, options);
    };
    s.src = 'https://meinebewertungen.pkw.de/js/widget.js';
    this.$refs.rating.appendChild(s);
  }
};
</script>

<style lang="scss">
@import "~@/assets/vars";

.vorteile.base-station {
  .vorteile-container {
  background: $red;
  box-shadow: inset -60px 30px 99px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  @include breakpoint(fromgiant) {
    background: transparent;
    box-shadow: none;
    border-radius: 0;
  }
}
.vorteile-block {
  color: $white;
  padding-left: 18px;
  padding-right: 18px;
  padding-top: 15px;
  padding-bottom: 12px;
  position: relative;

  @include breakpoint(frommediumlarge) {
      padding-top: 45px;
      padding-bottom: 22px;
  }

  @include breakpoint(fromgiant) {
    padding-left: 47%;
    
    background: $red;
    box-shadow: inset -60px 30px 99px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;

    &:before {
      content: "";
      display: block;
      width: 550px;
      height: 516px;
      background-image: url("../assets/driver-hand.png");
      background-size: cover;
      background-position: center;
      position: absolute;
      bottom: 0;
      left: -10px;
    }
  }

  @include breakpoint(extralarge) {
      padding-left: 46%;
      padding-top: 80px;
        padding-bottom: 97px;

    &:before {
        width: 600px;
        height: 563px;
    }
  }

  @include breakpoint(full) {
      &:before {
        width: 676px;
        height: 634px;
    }
  }

  .vorteile-title {
    font-size: 30px;
    line-height: 50px;
    font-weight: 600;
    margin-bottom: 14px;

    @include breakpoint(frommediumlarge) {
        font-size: 40px;
        line-height: 91px;
    }

    @include breakpoint(fromgiant) {
      font-size: 60px;
      margin-bottom: 31px;
    }
  }

  .vorteile-list {
    padding: 0;
    li {
      position: relative;
      font-size: 26px;
      line-height: 36px;
      margin-bottom: 14px;
      padding-left: 36px;

      @include breakpoint(frommediumlarge) {
        margin-bottom: 34px;
      }

      &:before {
        content: "";
        display: block;
        width: 24px;
        height: 19px;
        background-image: url("../assets/check-white.svg");
        position: absolute;
        left: 0;
        top: 8px;
      }
    }
  }
}

.partners-and-trustpilot {
  .inner-wrap {
    padding-bottom:35px;
    @include breakpoint(frommediumlarge) {
        padding-top: 10px;
        padding-bottom: 50px;
    }

    @include breakpoint(fromlarge) {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }

    @include breakpoint(fromgiant) {
      padding-top: 220px;
    }

    @include breakpoint(extralarge) {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        justify-content: space-between;
        
        padding-bottom: 30px;
    }

    .partners {
      display: flex;
      flex-wrap:wrap;
      align-items: center;
      margin-top: 20px;

      @include breakpoint(frommediumlarge) {
        margin-bottom:20px;
      }
      
      @include breakpoint(fromlarge) {
        width: 100%;
        margin-bottom:40px;
      }
      
      @include breakpoint(extralarge) {
        margin-top: initial;
        padding-left:30px;
        width:30%;
        order:2;
        margin-bottom:0;
      }

      @include breakpoint(full) {
        width:25%;
      }

      &-icons {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-end; 

        @include breakpoint(extralarge) {
          justify-content: start;
        }
        
        .partner-logo03 {
          align-self: flex-start;
        }
      }

      .section-title {
        font-weight: initial;
        width:100%;
        display:block;

        font-size: 14px;
        line-height: 26px;
        text-align: center;

        margin-bottom: 10px;

        @include breakpoint(fromsmall) {
          font-size: 20px;
          line-height: 24px;
          font-weight: bold;
          margin-bottom: 15px;
        }

        @include breakpoint(frommediumlarge) {
        }

        @include breakpoint(fromlarge) {
            font-size: 25px;
            line-height: 30px;
        }

        @include breakpoint(extralarge) {
          margin-right: 50px;
        }

        @include breakpoint(extralarge) {
          text-align: initial;
        }
      }

      a {
        img {
          display: block;
        }

        &.partner-logo {
          &.partner-logo01 {
            img {
              width:49px;
            }
          }

          &.partner-logo02 {
            img {
              width:152px;
            }
          }

          &.partner-logo03 {
            img {
              width:65px;
            }
          }
        }

        &:not(:last-of-type) {
          margin-right: 25px;
          margin-bottom:20px;

          @include breakpoint(frommediumlarge) {
            margin-bottom:0;
          }

          @include breakpoint(extralarge) {
            margin-right: 40px;
          }
        }
      }
    }

    .statistic {
      text-align: center;

      @include breakpoint(fromlarge) {
        width: 100%;
        text-align: center;
        margin-bottom: 25px;
      }

      @include breakpoint(extralarge) {
        padding: 0 30px;

        width: initial;
        text-align: initial;
        margin-bottom: initial;
      }

      &-info {
        display: inline-block;
        font-weight: 700;
        margin: 0;
        font-size: 18px;

        @include breakpoint(fromsmall) {
          font-size: 20px;
          margin-right: 5px;
        }

        @include breakpoint(frommediumlarge) {
          font-size: 30px;
        }

        @include breakpoint(extralarge) {
          display: block;
          font-size: 38px;
          line-height: 1.2;
        }
      }

      &-text {
        display: inline-block;
        font-weight: 700;
        font-size: 18px;
        margin: 0;

        @include breakpoint(fromsmall) {
          font-size: 20px;
        }

        @include breakpoint(frommediumlarge) {
          font-size: 30px;
        }

        @include breakpoint(extralarge) {
          display: block;
          font-size: 25px;
          font-weight: normal;
          line-height: 1.2;
          max-width: 300px;
        }
      }
    }

    .divider {
      display:none;

      &.red {
        background: #C0141B;
        width: 3px;
      }

      @include breakpoint(extralarge) {
        display:block;
        height: 132px;
        width: 1px;
        background: $dark-light;
        order:1;
      }
    }

    .trustpilot {
      font-size: 25px;
      line-height: 30px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap:wrap;

      @include breakpoint(frommediumlarge) {
        margin-top:40px;
        flex-wrap:wrap;
        font-size: 30px;
        line-height: 50px;
      }

      @include breakpoint(fromlarge) {
            margin-top:0;
            font-size: 25px;
          line-height: 30px;
          white-space: nowrap;
          justify-content: space-between;
          width: 100%;
      }

      // @include breakpoint(fromgiant) {
      // }
      
      @include breakpoint(extralarge) {
        padding-left:30px;
        font-size: 30px;
        line-height: 50px;
        width: 40%;
        order:0;
        padding-left:0;
        // width: 62%;
        // padding-left:0;
      }

      // @include breakpoint(full) {
      //   width: 40%;
      // }

      .trust-items {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

       
        @include breakpoint (frommediumlarge) {
          // justify-content: start;
        }

        @include breakpoint(fromlarge) {
          flex-direction: row;
        }

        @include breakpoint(extralarge) {
          justify-content: space-between;
        }
      
        .rating-widget.base-rating-widget {
          transform: none;
        }
        .trustpilot-widget {
          display:none;

          @include breakpoint (fromlarge) {
            display:block;
          }
        }
        
        .WidgetBannerContainer {
          .WidgetBanner {
            display: block !important;
            margin-bottom: -15px;
          }

          .widgetFlex {
            display: none;
          }

        }
      }

      .section-title {
        font-weight: initial;
        width:100%;
        display:block;

        font-size: 14px;
        line-height: 26px;
        text-align: center;
        margin-bottom:10px;

        @include breakpoint(fromsmall) {
          font-size: 20px;
          line-height: 24px;
          font-weight: bold;
          margin-bottom: 15px;
        }
        
        @include breakpoint(fromlarge) {
          font-size: 25px;
          line-height: 30px;
        }

        @include breakpoint(extralarge) {
          text-align: initial;
        }
        
      }

      .google-rating-widget {
        margin-bottom:20px;
        margin-right:20px;

        @include breakpoint(frommediumlarge) {
          margin-bottom:0;
        }

        img {
          @include breakpoint(fromgiant) {
            width:200px;
            min-width: 200px;
          }
          @include breakpoint(extralarge) {
            width:auto;
            min-width: auto;
          }
        }
      }

      .trustpilot-widget {
          margin-top:25px;

          @include breakpoint(frommediumlarge) {
              margin-top:0;
          }
      }
    }
  }
}
}
</style>



// WEBPACK FOOTER //
// src/station-components/Vorteile.vue